import { Component, Prop, Vue } from "vue-property-decorator";

@Component
class XInput extends Vue {

  @Prop({default: null}) readonly placeholder!: string;
  @Prop({default: null, type: [String, Number]}) readonly value!: number | string;
  @Prop({type: String, default: "string"}) readonly ofType: "number" | "string" | "integer";
  @Prop({ type: Boolean, default: true }) readonly controlled: boolean;
  @Prop({ type: Boolean, default: false }) readonly locked: boolean;
  @Prop({ type: Boolean, default: false }) readonly readonly: boolean;
  @Prop({ type: Boolean, default: false }) readonly autofocus: boolean;

  hasValue(value:string){
    return value !== null && typeof value !== "undefined" && value.length > 0;
  }

  validNumericOrNull(num:number){
    return isNaN(num) ? null : num;
  }

  couldBeStartOfNegative(num){
    return num.length === 1 && num === "-";
  }

  couldEndWithDot(num){
    return countChars(num, /\./) === 1 && num.endsWith(".");
  }

  parseFloat(num:string, enforceValidation){
    if(enforceValidation === false && (this.couldEndWithDot(num) || this.couldBeStartOfNegative(num))) return num;
    return this.validNumericOrNull(parseFloat(num));
  }

  parseInt(num:string, enforceValidation){
    if(enforceValidation === false && this.couldBeStartOfNegative(num)) return num;
    return this.couldBeStartOfNegative(num) ? num : this.validNumericOrNull(parseInt(num, 10));
  }

  castValue(v: string, enforceValidation:boolean) {
    if( ! this.hasValue(v)) return null;
    switch (this.ofType) {
      case "number": return this.parseFloat(v, enforceValidation);
      case "integer": return this.parseInt(v, enforceValidation);
      default: return v;
    }
  }

  filter(value){
    if(typeof value === "string"){
      if(this.ofType === "integer") return value.replace(/\D/g,"");
      if( this.ofType === "number") return value.replace(/[^0-9.\-]/, "");
    }
    return value;
  }

  onInput(e) {
    this.commit(e, false);
  }

  commit(e, enforceValidation){
    let value = this.castValue(this.filter(e.target.value), enforceValidation);
    // if( this.controlled) e.target.value = value;
    this.$emit("input", value);
  }

  forward(type) {
    return (...args) => {
      this.$emit.apply(this, [type, ...args]);
    };
  }

  focus(){
    this.$refs.input && (this.$refs.input as HTMLInputElement).focus();
  }

  select(){
    let input = (this.$refs.input as HTMLInputElement);
    input && input.setSelectionRange(0, input.value.length,"forward");
  }

  mounted() {
    if( this.autofocus && this.ofType === "string"){
      this.focus();
      this.select();
    }
  }

  render() {
    return (
      <input
        ref="input"
        class="input is-small"
        value={this.value}
        placeholder={this.placeholder}
        onInput={this.onInput}
        readonly={this.readonly}
        onKeydown={this.forward("keydown")}
        onKeyup={this.forward("keyup")}
        disabled={this.locked}
        type={this.ofType === "string" ? "text" : "number"}
        step="any"
      />
    )
  }
}


function countChars(str:string, char: RegExp){
  return (str.match(char) || [] ).length;
}

export {XInput};

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-491f915f/x-input.tsx" });